import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box } from '@mui/material';
import BurbujasLoader from './UIElements/BurbujasLoader';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <BurbujasLoader />
            </Box>
        );
    }

    if (!user) {
        // Redirect to login but save the current location to redirect back after login
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && Array.isArray(allowedRoles) && !allowedRoles.includes(user.rol)) {
        return <Navigate to="/principal" replace />;
    }

    return children;
};

export default ProtectedRoute;
